// Version : 1.0.0
// Author : AGALYA

const PancardDetailsActionType = {
	/** ***************** Pancard Update Start ************************/
	UPDATE_PANCARD_START: 'update_pancard_start',
	UPDATE_PANCARD_SUCCESS: 'update_pancard_success',
	UPDATE_PANCARD_FAILURE: 'update_pancard_failure',
	UPDATE_PANCARD_RESPONSE_REST_START: 'update_pancard_response_reset_start',
	UPDATE_PANCARD_RESPONSE_CHANGED: 'update_pancard_response_changed',
	/** ***************** Pancard Update End ************************/
};

export default PancardDetailsActionType;
